jQuery(function ($) {
    const homeParent = $(".home-filters-form");
    const DEBUG = false;
    const VEHICLE_CATEGORIES = ['cars', 'trucks', 'motorcycles', 'agriculture'];
    const homeMakesLoading = {};

    function trackHomeCatalogSearch(filterData, categoryOverride) {
        if (!window.CarBuyAnalytics || typeof window.CarBuyAnalytics.trackCatalogSearch !== 'function') {
            return;
        }
        const category = categoryOverride || (filterData && filterData.category) || 'catalog';
        const searchParts = [
            filterData && (filterData.make_name || filterData.make) || '',
            filterData && (filterData.model_name || filterData.model) || ''
        ].filter(function (part) { return String(part || '').trim() !== ''; });
        window.CarBuyAnalytics.trackCatalogSearch({
            search_string: searchParts.length ? searchParts.join(' ') : category,
            content_category: category,
            source: 'home_filters'
        });
    }

    function getHomeManufacturerSelectize($pane) {
        const el = $pane.find('[name="form-home-filters-manufacturer"]').get(0);
        return el && el.selectize ? el.selectize : null;
    }

    function homeMakesAlreadyLoaded($pane) {
        if ($pane.attr('data-makes-loaded') === '1') return true;
        const $makeSelect = $pane.find('[name="form-home-filters-manufacturer"]');
        return $makeSelect.find('option').length > 1;
    }

    function populateHomeMakeSelect($pane, makes) {
        const selectize = getHomeManufacturerSelectize($pane);
        if (!selectize) return;
        const placeholder = $pane.find('[name="form-home-filters-manufacturer"] option:first').text() || '';
        selectize.clearOptions();
        if (placeholder) {
            selectize.addOption({ value: '', text: placeholder });
        }
        (makes || []).forEach(function (make) {
            if (!make || typeof make.id === 'undefined') return;
            selectize.addOption({ value: String(make.id), text: make.name || String(make.id) });
        });
        selectize.refreshOptions(false);
        selectize.enable();
        $pane.attr('data-makes-loaded', '1');
    }

    function ensureHomeMakesLoaded(category, $pane) {
        if (!category || VEHICLE_CATEGORIES.indexOf(category) === -1) return;
        if (!$pane || !$pane.length) return;
        if (homeMakesAlreadyLoaded($pane)) {
            $pane.attr('data-makes-loaded', '1');
            return;
        }
        if (homeMakesLoading[category]) return;
        homeMakesLoading[category] = true;

        csrfSafeAjaxPost(
            '/ajax/get-makes',
            { category: category },
            function (response) {
                homeMakesLoading[category] = false;
                if (response && response.success && response.makes) {
                    populateHomeMakeSelect($pane, response.makes);
                }
            },
            function () {
                homeMakesLoading[category] = false;
            }
        );
    }

    // Clean up Selectize hidden elements
    function cleanupSelectizeHiddenElements() {
        // Remove Selectize hidden measurement elements
        $('div[style*="position: absolute"][style*="width: 0px"][style*="height: 0px"][style*="overflow: hidden"]').remove();
        $('div[aria-hidden="true"][style*="position: absolute"][style*="width: 0px"]').remove();
    }

    // Helpers to collect and persist filters immediately
    function getActiveHomePane($scope) {
        const $root = $scope && $($scope).length ? $($scope) : homeParent;
        // If scope is inside a pane (form is child of pane), prefer that parent
        let $pane = $root.closest('.tab-pane');
        if ($pane && $pane.length) return $pane;
        // Otherwise, search within the scope for visible/active panes
        $pane = $root.find('.tab-pane:visible').first();
        if (!$pane.length) $pane = $root.find('.tab-pane.active').first();
        if (!$pane.length) $pane = $root.find('.tab-pane').first();
        return $pane;
    }
    function getSelectedCategory($pane, $scope) {
        const $container = $scope && $($scope).length ? $($scope).closest('.home-filters-inner-container') : $('.home-filters-inner-container');
        const tabCatScoped = $container.find('.home-filters-category-link.active').data('category');
        const tabCatGlobal = $('.home-filters-category-link.active').data('category') || $('.home-filters-category-link').first().data('category');
        const paneId = ($pane && $pane.attr) ? ($pane.attr('id') || '') : '';
        const linkByHrefScoped = paneId ? $container.find('.home-filters-category-link[href="#' + paneId + '"]').data('category') : '';
        const linkByHrefGlobal = paneId ? $('.home-filters-category-link[href="#' + paneId + '"]').data('category') : '';
        const paneDataCat = $pane.data('category');
        const hiddenCatInPane = $pane.find('.home-filters-category-value').val();
        const hiddenCatGlobal = $('.home-filters-category-value').first().val();
        const namedCatInPane = $pane.find('[name="form-home-filters-category"]').val();
        const namedCatScoped = $container.find('[name="form-home-filters-category"]').val();
        const namedCatGlobal = $('[name="form-home-filters-category"]').first().val();
        return tabCatScoped || linkByHrefScoped || tabCatGlobal || linkByHrefGlobal || paneDataCat || hiddenCatInPane || hiddenCatGlobal || namedCatInPane || namedCatScoped || namedCatGlobal || '';
    }
    function collectHomeFilters($scope) {
        const $form = $scope && $($scope).length ? $($scope) : $('.home-filters-form').first();
        const $activePane = $form.closest('.tab-pane').length ? $form.closest('.tab-pane') : getActiveHomePane($scope);

        // Resolve category robustly
        const category = getSelectedCategory($activePane, $scope);

        // Wheels home search -> redirect to /catalog/wheels with GET params (no localStorage persistence)
        if (category === 'wheels') {
            return {
                category: category,
                diameter_in: $form.find('[name="form-home-filters-diameter_in"]').val() || '',
                width_in: $form.find('[name="form-home-filters-width_in"]').val() || '',
                bolt_count: $form.find('[name="form-home-filters-bolt_count"]').val() || '',
                pcd_mm: $form.find('[name="form-home-filters-pcd_mm"]').val() || '',
                et_mm: $form.find('[name="form-home-filters-et_mm"]').val() || '',
                cb_mm: $form.find('[name="form-home-filters-cb_mm"]').val() || '',
                has_tires: $form.find('[name="form-home-filters-has_tires"]').val() || '',
                price_from: $form.find('[name="form-home-filters-price_from"]').val() || '',
                price_to: $form.find('[name="form-home-filters-price_to"]').val() || '',
                sort: 'latest'
            };
        }

        // Trailers home search -> redirect to /catalog/trailers with GET params (no localStorage persistence)
        if (category === 'trailers') {
            return {
                category: category,
                trailer_type: $form.find('[name="form-home-filters-trailer_type"]').val() || '',
                suspension: $form.find('[name="form-home-filters-suspension"]').val() || '',
                brakes: $form.find('[name="form-home-filters-brakes"]').val() || '',
                axle_count: $form.find('[name="form-home-filters-axle_count"]').val() || '',
                max_mass_from: $form.find('[name="form-home-filters-max_mass_from"]').val() || '',
                max_mass_to: $form.find('[name="form-home-filters-max_mass_to"]').val() || '',
                price_from: $form.find('[name="form-home-filters-price_from"]').val() || '',
                price_to: $form.find('[name="form-home-filters-price_to"]').val() || '',
                sort: 'latest'
            };
        }

        // Get make and model names from Selectize in active pane
        let makeId = '';
        let modelId = '';
        let makeName = '';
        let modelName = '';

        const makeSelect = $form.find('[name="form-home-filters-manufacturer"]').get(0)?.selectize;
        if (makeSelect && makeSelect.getValue()) {
            makeId = makeSelect.getValue();
            const makeOption = makeSelect.options[makeId];
            makeName = makeOption ? makeOption.text : '';
        }

        const modelSelect = $form.find('[name="form-home-filters-model"]').get(0)?.selectize;
        if (modelSelect && modelSelect.getValue()) {
            modelId = modelSelect.getValue();
            const modelOption = modelSelect.options[modelId];
            modelName = modelOption ? modelOption.text : '';
        }

        // Collect posts-type and map to seller_type.
        // posts-type: "own" / "cdauto" / "club" / "all" -> seller_type: "carbuy" / "cdauto" / "carbuyclub" / "all"
        const postsType = $form.find('input[name="posts-type"]:checked').val() || 'own';
        let sellerType = 'carbuy';
        if (postsType === 'cdauto') {
            sellerType = 'cdauto';
        } else if (postsType === 'club') {
            sellerType = 'carbuyclub';
        } else if (postsType === 'all') {
            sellerType = 'all';
        }

        return {
            category: category,
            v_type: category, // Set v_type to match category for backend filtering
            make_id: makeId,
            model_id: modelId,
            make: makeName,
            model: modelName,
            engine_type: $form.find('[name="form-home-filters-fuel"]').val() || '',
            gearbox: $form.find('[name="form-home-filters-gearbox"]').val() || '',
            body_type: $form.find('[name="form-home-filters-body-type"]').val() || '',
            seats: $form.find('[name="form-home-filters-seats"]').val() || '',
            seller_type: sellerType,
            sort: 'latest'
        };
    }
    function persistHomeFilters($scope) {
        const f = collectHomeFilters($scope);
        // Keep car catalog localStorage clean: only persist for vehicle categories.
        if (!f || !f.category || VEHICLE_CATEGORIES.indexOf(f.category) === -1) return;
        try { localStorage.setItem('catalog_filters', JSON.stringify(f)); } catch (e) {}
    }

    function buildQueryString(params) {
        const out = [];
        if (!params) return '';
        Object.keys(params).forEach((k) => {
            const v = params[k];
            if (v === null || typeof v === 'undefined') return;
            const s = String(v);
            if (!s || !s.trim()) return;
            out.push(encodeURIComponent(k) + '=' + encodeURIComponent(s));
        });
        return out.join('&');
    }

    // ---- Recent searches (home page pills) ----
    function ensureRecentSearchesHomeUI() {
        const $container = $('.home-filters-inner-container');
        if (!$container.length) return null;

        let $wrap = $container.find('.recent-searches--home');
        if ($wrap.length) return $wrap;

        // Place below the filter card (bottom of the search form area)
        $wrap = $(`
            <div class="recent-searches recent-searches--home">
                <div class="recent-searches-header d-flex justify-content-between align-items-center">
                    <div class="recent-searches-title">${(typeof window.recentSearchesTranslations !== 'undefined' && window.recentSearchesTranslations.title) ? window.recentSearchesTranslations.title : 'Pēdējie meklējumi'}</div>
                    <button type="button" class="recent-searches-clear">${(typeof window.recentSearchesTranslations !== 'undefined' && window.recentSearchesTranslations.clear) ? window.recentSearchesTranslations.clear : 'Notīrīt'}</button>
                </div>
                <div class="recent-searches-chips" role="list"></div>
            </div>
        `);

        const $inner = $container.find('.home-filters-inner').last();
        if ($inner.length) {
            // Insert INSIDE the filter card (so it sits within the default-border-radius container)
            $inner.append($wrap);
        } else {
            $container.append($wrap);
        }

        return $wrap;
    }

    function renderRecentSearchesHome() {
        const api = window.CarBuyRecentSearches;
        if (!api || typeof api.list !== 'function') return;

        const $wrap = ensureRecentSearchesHomeUI();
        if (!$wrap) return;

        const list = api.list() || [];
        const $chips = $wrap.find('.recent-searches-chips');
        $chips.empty();

        if (!list.length) {
            $wrap.hide();
            return;
        }

        list.forEach((entry) => {
            if (!entry || !entry.key) return;
            const label = entry.label || (api.label ? api.label(entry.filters) : 'Search');
            const tooltip = (api.tooltip && entry.filters) ? api.tooltip(entry.filters) : '';
            const $chip = $(`
                <div class="recent-search-chip" role="listitem">
                    <button type="button" class="recent-search-chip-btn" data-recent-key=""></button>
                    <button type="button" class="recent-search-chip-remove" aria-label="Remove" data-recent-key="">×</button>
                </div>
            `);
            $chip
                .find('.recent-search-chip-btn')
                .attr('data-recent-key', entry.key)
                .attr('title', tooltip || label)
                .text(label);
            $chip.find('.recent-search-chip-remove').attr('data-recent-key', entry.key);
            $chips.append($chip);
        });

        $wrap.show();
    }

    // Live-update the home "latest cars" block on toggle (All vs CarBuy)
    let latestCarsRequest = null;
    let latestCarsTimer = null;

    function revealHomeLatestCars($container) {
        const $cars = $container.find('.single-car.before-animation-visibility-backface');
        let i = 0;
        (function showNext() {
            if (i >= $cars.length) return;
            $cars.eq(i).removeClass('before-animation-visibility-backface');
            i++;
            setTimeout(showNext, 150);
        })();
    }

    function updateHomeLatestCars($scope) {
        const $target = $('#home-latest-cars');
        if (!$target.length) return;

        const filters = collectHomeFilters($scope);
        const sellerType = (filters && (filters.seller_type === 'carbuy' || filters.seller_type === 'cdauto' || filters.seller_type === 'carbuyclub' || filters.seller_type === 'all'))
            ? filters.seller_type
            : 'carbuy';
        const limit = parseInt($target.data('limit'), 10);
        const requestData = { seller_type: sellerType };
        if (!isNaN(limit) && limit > 0) {
            requestData.limit = limit;
        }

        // Abort any in-flight request so the latest toggle always wins
        if (latestCarsRequest && typeof latestCarsRequest.abort === 'function') {
            latestCarsRequest.abort();
        }

        $target.attr('aria-busy', 'true');

        latestCarsRequest = csrfSafeAjaxPost(
            '/ajax/home/latest-cars',
            requestData,
            function (response) {
                if (response && response.success && typeof response.html === 'string') {
                    $target.html(response.html);
                    revealHomeLatestCars($target);
                }
            },
            function (xhr, status) {
                // Ignore aborts
                if (status === 'abort') return;
                try { console.error('[HOME] Failed to load latest cars:', status); } catch (e) {}
            },
            function () {
                $target.attr('aria-busy', 'false');
            }
        );
    }

    function requestHomeLatestCarsUpdate($scope, delay = 150) {
        clearTimeout(latestCarsTimer);
        latestCarsTimer = setTimeout(function () {
            updateHomeLatestCars($scope);
        }, delay);
    }

    // Render a summary of selected filters on the home page
    function renderSelectedFiltersSummary(filters) {
        if (!filters) return;
        let $summary = $('.home-filters-selected-summary');
        if (!$summary.length) {
            $summary = $('<div class="home-filters-selected-summary" />');
            const $title = $('<div class="home-filters-selected-title" />').text('Selected filters');
            const $chips = $('<div class="home-filters-selected-chips" />');
            $summary.append($title).append($chips);
            homeParent.after($summary);
        }
        const $chips = $summary.find('.home-filters-selected-chips');
        $chips.empty();

        function addChip(label, value) {
            if (!value) return;
            const $chip = $('<span class="home-filter-chip" />');
            $chip.append($('<strong />').text(label + ': '));
            $chip.append($('<span />').text(value));
            $chips.append($chip);
        }

        addChip('Category', filters.category);
        addChip('Make', filters.make);
        addChip('Model', filters.model);
        addChip('Fuel', filters.engine_type);
        addChip('Gearbox', filters.gearbox);
        addChip('Body', filters.body_type);
        addChip('Seats', filters.seats);
        if (filters.seller_type && filters.seller_type !== 'all') addChip('Seller', filters.seller_type);

        $summary.show();
        try { console.log('[HOME FILTERS] Selected:', filters); } catch (e) {}
    }

    // Initialize all selectize instances first
    $('.home-filter-selectize').selectize({
        plugins: ["clear_on_focus"],
        onInitialize: function() {
            this.enable();
            // Clean up any existing hidden elements
            cleanupSelectizeHiddenElements();
        },
        onDestroy: function() {
            // Clean up hidden elements when selectize is destroyed
            cleanupSelectizeHiddenElements();
        },
        onChange: function (value) {
            // Handle make change to load models
            if ($(this.$input).attr('name') === 'form-home-filters-manufacturer') {
                const modelSelect = $(this.$input).closest('.tab-pane').find('select[name="form-home-filters-model"]').get(0)?.selectize;
                if (modelSelect) {
                    modelSelect.clear(true);
                    modelSelect.clearOptions();
                    modelSelect.disable();
                    if (value) {
                        // Use the same endpoint and logic as catalog
                        csrfSafeAjaxPost(
                            '/ajax/get-models',
                            { make_id: value },
                            function(response) {
                                if (response.success && response.models) {
                                    modelSelect.clearOptions();
                                    response.models.forEach(function(model) {
                                        modelSelect.addOption({
                                            value: model.id,
                                            text: model.name,
                                            slug: model.slug
                                        });
                                    });
                                    modelSelect.enable();
                                }
                            },
                            function(xhr) {
                                if (xhr.status === 403) {
                                    console.error('CSRF token expired');
                                }
                            }
                        );
                    } else {
                        modelSelect.enable();
                    }
                }
                // Persist immediately after brand change
                persistHomeFilters($(this.$input).closest('.home-filters-form'));
            }
            if ($(this.$input).attr('name') === 'form-home-filters-model') {
                // Persist immediately after model change
                persistHomeFilters($(this.$input).closest('.home-filters-form'));
            }
        }
    });

    // Handle form submission
    homeParent.on("submit", function(e) {
        e.preventDefault();
		// Debug: Show which tab is selected before collecting filters
        if (DEBUG) {
            try {
                const $scope = $(this);
                console.log('Homeparent:', homeParent);
                console.log('$scope:', $scope);
                // Prefer the pane that contains this form
                let $pane = $scope.closest('.tab-pane');
                if (!$pane.length) $pane = getActiveHomePane($scope);
                const paneId = ($pane && $pane.attr) ? ($pane.attr('id') || '') : '';
                // Find the corresponding nav link by href within the same filters container
                const $container = $scope.closest('.home-filters-inner-container');
                let $activeLinkScoped = paneId ? $container.find('.home-filters-category-link[href="#' + paneId + '"]') : $container.find('.home-filters-category-link.active');
                if (!$activeLinkScoped.length) $activeLinkScoped = $('.home-filters-category-link.active').first();
                const activeLinkCat = $activeLinkScoped.data('category') || '';
                const activeLinkText = $.trim($activeLinkScoped.find('span').text() || $activeLinkScoped.text() || '');
                const activeHref = $activeLinkScoped.attr('href') || '';
                const paneClasses = ($pane && $pane.attr) ? ($pane.attr('class') || '') : '';
                const paneHiddenCat = $pane.find('.home-filters-category-value').val() || '';
                console.log('[HOME DEBUG] Active link on submit:', { text: activeLinkText, category: activeLinkCat, href: activeHref });
                console.log('[HOME DEBUG] Active pane on submit:', { id: paneId, classes: paneClasses, hiddenCategory: paneHiddenCat });
                const tabCatScoped = $container.find('.home-filters-category-link.active').data('category') || '';
                const tabCatGlobal = $('.home-filters-category-link.active').data('category') || '';
                const paneDataCat = ($pane && $pane.data) ? ($pane.data('category') || '') : '';
                const hiddenCatInPane = paneHiddenCat;
                console.log('[HOME DEBUG] Submit tab selection:', {
                    tabCatScoped,
                    tabCatGlobal,
                    paneDataCat,
                    hiddenCatInPane
                });
            } catch (e) {}
        }
        let filterData = collectHomeFilters(this);
		if (DEBUG) try { console.log('[HOME DEBUG] Resolved category on submit:', filterData.category); } catch (e) {}

        const category = (filterData && filterData.category) ? filterData.category : 'cars';

        // Wheels/trailers use server-side GET filters; keep car catalog localStorage untouched.
        if (category === 'wheels') {
            trackHomeCatalogSearch(filterData, 'wheels');
            const qs = buildQueryString({
                sort: 'latest',
                diameter_in: filterData.diameter_in,
                width_in: filterData.width_in,
                bolt_count: filterData.bolt_count,
                pcd_mm: filterData.pcd_mm,
                et_mm: filterData.et_mm,
                cb_mm: filterData.cb_mm,
                has_tires: filterData.has_tires,
                price_from: filterData.price_from,
                price_to: filterData.price_to
            });
            window.location.href = '/catalog/wheels' + (qs ? ('?' + qs) : '') + '#open-filters';
            return;
        }
        if (category === 'trailers') {
            trackHomeCatalogSearch(filterData, 'trailers');
            const qs = buildQueryString({
                sort: 'latest',
                category: filterData.trailer_type, // map trailer_type -> GET category
                suspension: filterData.suspension,
                brakes: filterData.brakes,
                axle_count: filterData.axle_count,
                max_mass_from: filterData.max_mass_from,
                max_mass_to: filterData.max_mass_to,
                price_from: filterData.price_from,
                price_to: filterData.price_to
            });
            window.location.href = '/catalog/trailers' + (qs ? ('?' + qs) : '') + '#open-filters';
            return;
        }

        // Persist to localStorage so car catalog page can restore filters
        if (filterData && filterData.category && VEHICLE_CATEGORIES.indexOf(filterData.category) !== -1) {
            try { localStorage.setItem('catalog_filters', JSON.stringify(filterData)); } catch (err) {}
        }

        // Save to recent searches so user can re-open it later
        // Requirement: only save when make + model are selected (avoid clutter from partial searches)
        try {
            const hasMake = !!(filterData && (filterData.make_id || filterData.make));
            const hasModel = !!(filterData && (filterData.model_id || filterData.model));
            if (hasMake && hasModel && window.CarBuyRecentSearches && typeof window.CarBuyRecentSearches.upsert === 'function') {
                window.CarBuyRecentSearches.upsert(filterData);
            }
        } catch (e) {}

        trackHomeCatalogSearch(filterData, category);

        // Redirect to catalog with the selected category
        window.location.href = '/catalog/' + category + '#open-filters';
    });

    // Recent search actions (home page)
    $(document).on('click', '.recent-searches--home .recent-search-chip-btn', function (e) {
        e.preventDefault();
        const key = $(this).attr('data-recent-key') || '';
        const api = window.CarBuyRecentSearches;
        if (!api || !key || typeof api.get !== 'function') return;
        const entry = api.get(key);
        if (!entry || !entry.filters) return;
        const filters = entry.filters;
        try { localStorage.setItem('catalog_filters', JSON.stringify(filters)); } catch (e2) {}
        const category = (filters.category || filters.v_type || 'cars');
        window.location.href = '/catalog/' + category + '#open-filters';
    });

    $(document).on('click', '.recent-searches--home .recent-search-chip-remove', function (e) {
        e.preventDefault();
        const key = $(this).attr('data-recent-key') || '';
        const api = window.CarBuyRecentSearches;
        if (!api || !key || typeof api.remove !== 'function') return;
        api.remove(key);
        renderRecentSearchesHome();
    });

    $(document).on('click', '.recent-searches--home .recent-searches-clear', function (e) {
        e.preventDefault();
        const api = window.CarBuyRecentSearches;
        if (!api || typeof api.clear !== 'function') return;
        api.clear();
        renderRecentSearchesHome();
    });

    // Category tab switching (UI only) – use Bootstrap's shown event so active pane/link are updated
    homeParent.on('shown.bs.tab', '.home-filters-category-link', function(e) {
        const $tab = $(e.target);
        const category = $tab.data('category');
        let $scope = $tab.closest('.home-filters-form');
        if (!$scope.length) { $scope = homeParent; }
        const target = $tab.attr('href');
        // Sync hidden category in target pane
        if (target && target.charAt(0) === '#') {
            const $pane = $(target);
            $pane.find('.home-filters-category-value').val(category);

            // Clear filters only in the newly activated pane (all selects + numeric inputs)
            $pane.find('select').each(function () {
                const sel = this && this.selectize ? this.selectize : null;
                if (sel) {
                    sel.clear(true);
                    // Model select depends on make; keep previous behavior
                    if ($(this).attr('name') === 'form-home-filters-model') {
                        sel.clearOptions();
                        sel.disable();
                    }
                } else {
                    $(this).val('');
                }
            });
            $pane.find('input[type="number"]').val('');
            ensureHomeMakesLoaded(category, $pane);
        }
        // Keep named inputs in sync for this form scope
        $scope.find('.home-filters-category-value').val(category);
        $scope.find('[name="form-home-filters-category"]').val(category);
        // Reset seller type to default within this form scope
        $scope.find('input[name="form-home-filters-seller-type"]').prop('checked', false);
        $scope.find('input[name="form-home-filters-seller-type"][value="all"]').prop('checked', true);
        // Reset posts-type to default within this form scope
        $scope.find('input[name="posts-type"]').prop('checked', false);
        $scope.find('input[name="posts-type"][value="own"]').prop('checked', true);
        const $toggleWrap = $('.home-page .home-seller-type-toggle');
        if ($toggleWrap.length) {
            $toggleWrap.find('.seller-type-toggle-btn').removeClass('active').attr('aria-pressed', 'false');
            $toggleWrap.find('.seller-type-toggle-btn[data-posts-type="own"]').addClass('active').attr('aria-pressed', 'true');
        }
        // Persist immediately after category change
        persistHomeFilters($scope);
        // Also refresh the home "latest cars" list (it resets to CarBuy on category switch)
        requestHomeLatestCarsUpdate($scope, 0);
    });

    // Initialize on page load
    $(document).ready(function() {
        if (!$('.home-filters-category-link.active').length) {
            $('.home-filters-category-link[data-category="cars"]').addClass('active');
        }
        // Ensure the active pane's hidden value matches the active link
        const $activeLink = $('.home-filters-category-link.active').first();
        const activeCat = $activeLink.data('category');
        const target = $activeLink.attr('href');
        if (target && target.charAt(0) === '#') {
            const $activePane = $(target);
            $activePane.find('.home-filters-category-value').val(activeCat || '');
            if (activeCat) {
                ensureHomeMakesLoaded(activeCat, $activePane);
            }
        }

        // Restore seller type (CarBuy vs All) from localStorage so selection survives reload
        let shouldRefreshLatestCars = true;
        try {
            const stored = localStorage.getItem('catalog_filters');
            if (stored) {
                const parsed = JSON.parse(stored);
                let sellerType = 'carbuy';
                if (parsed && (parsed.seller_type === 'all' || parsed.seller_type === 'cdauto' || parsed.seller_type === 'carbuyclub' || parsed.seller_type === 'carbuy')) {
                    sellerType = parsed.seller_type;
                }
                let postsValue = 'own';
                if (sellerType === 'cdauto') {
                    postsValue = 'cdauto';
                } else if (sellerType === 'carbuyclub') {
                    postsValue = 'club';
                } else if (sellerType === 'all') {
                    postsValue = 'all';
                }
                $('input[name="posts-type"]').prop('checked', false);
                $('input[name="posts-type"][value="' + postsValue + '"]').prop('checked', true);
                // Beta: sync toggle buttons if present
                const $toggleWrap = $('.home-page .home-seller-type-toggle');
                if ($toggleWrap.length) {
                    $toggleWrap.find('.seller-type-toggle-btn').removeClass('active').attr('aria-pressed', 'false');
                    $toggleWrap.find('.seller-type-toggle-btn[data-posts-type="' + postsValue + '"]').addClass('active').attr('aria-pressed', 'true');
                }
                if (sellerType !== 'carbuy') {
                    shouldRefreshLatestCars = true;
                }
            }
        } catch (e) {}

        // Load latest cars via AJAX (not server-rendered) to keep first HTML lean
        if (shouldRefreshLatestCars) {
            requestHomeLatestCarsUpdate(homeParent, 0);
        }

        // Render recent searches pills (home page)
        renderRecentSearchesHome();
    });

    // Immediate persistence for other fields
    $(document).on('change', '[name="form-home-filters-fuel"],[name="form-home-filters-gearbox"],[name="form-home-filters-body-type"],[name="form-home-filters-seats"]', function(){
        persistHomeFilters($(this).closest('.home-filters-form'));
    });
    $(document).on('change', 'input[name="posts-type"]', function(){
        const $scope = $(this).closest('.home-filters-form');
        persistHomeFilters($scope);
        requestHomeLatestCarsUpdate($scope, 0);
    });

    // Beta: seller-type toggle buttons (outside filters) – set all tab forms and refresh latest cars
    $(document).on('click', '.home-page .home-seller-type-toggle .seller-type-toggle-btn', function(e) {
        const btn = $(this);
        const postsType = btn.attr('data-posts-type');
        if (!postsType || (postsType !== 'all' && postsType !== 'own' && postsType !== 'cdauto' && postsType !== 'club')) return;
        e.preventDefault();
        $('.home-filters-inner-container input[name="posts-type"][value="' + postsType + '"]').prop('checked', true);
        $('.home-seller-type-toggle .seller-type-toggle-btn').removeClass('active').attr('aria-pressed', 'false');
        btn.addClass('active').attr('aria-pressed', 'true');
        persistHomeFilters($('.home-filters-form').first());
        requestHomeLatestCarsUpdate(homeParent, 0);
    });

    // Scrollable category lane: auto-scroll when pointer is near left/right edge
    (function() {
        const $lane = $('.home-page .home-filters-categories');
        if (!$lane.length) return;
        const el = $lane[0];
        const EDGE_ZONE = 80;
        const MAX_SPEED = 12;
        let direction = 0;
        let intensity = 0;

        function tick() {
            if (!el || direction === 0) return;
            const maxScroll = el.scrollWidth - el.clientWidth;
            if (maxScroll <= 0) return;
            const step = direction * MAX_SPEED * intensity;
            el.scrollLeft = Math.max(0, Math.min(maxScroll, el.scrollLeft + step));
            requestAnimationFrame(tick);
        }

        function updateFromClientX(clientX) {
            const rect = el.getBoundingClientRect();
            if (clientX >= rect.right - EDGE_ZONE && clientX <= rect.right) {
                direction = 1;
                intensity = (rect.right - clientX) / EDGE_ZONE;
            } else if (clientX >= rect.left && clientX <= rect.left + EDGE_ZONE) {
                direction = -1;
                intensity = (rect.left + EDGE_ZONE - clientX) / EDGE_ZONE;
            } else {
                direction = 0;
                intensity = 0;
            }
            if (direction !== 0) requestAnimationFrame(tick);
        }

        $lane.on('mousemove', function(e) {
            updateFromClientX(e.clientX);
        });
        $lane.on('mouseleave', function() {
            direction = 0;
            intensity = 0;
        });
        $lane.on('touchmove', function(e) {
            if (e.originalEvent.touches.length) {
                updateFromClientX(e.originalEvent.touches[0].clientX);
            }
        });
        $lane.on('touchend touchcancel', function() {
            direction = 0;
            intensity = 0;
        });
    })();
});